<template>
    <v-form v-model="valid" ref="opRegistry">
    <v-container>
        <v-row no-gutters>
            <v-col cols="6">
                <v-autocomplete dense outlined
                    :items="orgs"
                    v-model="c_data.org_id"
                    label="ente"
                    item-value="_id"
                    item-text="value.name"
                    :rules="[rules.mandatory]"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="6">
                <v-autocomplete dense outlined
                    :items="filtered_users"
                    v-model="c_data.assigned"
                    label="operatori"
                    item-value="_id"
                    item-text="name"
                    multiple
                    :rules="[rules.mandatory]"
                ></v-autocomplete>
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-text-field dense outlined
                    v-model="c_data.name"
                    label="nome"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="4">
                <v-text-field dense outlined
                    v-model="c_data.order_nr"
                    label="n° ordine*"
                    :rules="[rules.mandatory]"
                />
            </v-col>
            <v-col cols="4" class="pl-2">
                <CalendarField
                    :disabled="!isDateEditable()"
                    v-model="c_data.order_date"
                    label="data ordine*"
                    :rules="[rules.mandatory]"
                ></CalendarField>    
            </v-col>
            <v-col cols="4" class="pl-2">
                <CalendarField
                    :disabled="!isDateEditable()"
                    v-model="c_data.op_date"
                    :minDate="c_data.order_date"
                    label="data intervento*"
                    :rules="[rules.mandatory]"
                ></CalendarField>    
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <v-text-field dense outlined
                    v-model="c_data.desc"
                    label="note"
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="partners.length>0">
            <v-col cols="8">
                <v-autocomplete dense outlined
                    v-model="c_data.partner_id"
                    label="intermediario"
                    :items="partners"
                    item-text="name"
                    item-value="_id"
                    cache-items
                    clearable
                    />
            </v-col>
        </v-row>
                
    </v-container>
    </v-form>
</template>
<script>
// import _ from 'lodash'

import { f_rules, getDefaultOrderNr } from '../../utils/commonUtils'
import { filterByOrg, isAdmin } from '../../utils/rolesManagement'
import {searchDesign, orderByFields} from '../../utils/dbUtility.js'


export default {
    components: {},
    props: {
        o_data: {
            type: Object,
            required: false,
            default: null
        }
    },
    data(){
        return {
            c_data: {},
            rules: f_rules,
            valid: false,
            partners: [],
            filtered_users: [],
            orgs: []
        }
    },
    computed: {
        
    },
    async mounted() {
        console.log('mountde start')
        this.c_data = _.cloneDeep(this.o_data)
        if (isAdmin(this.$store.state.user.roles)){
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
            res = res.map(item => { return { _id: item.id, value: item.value } })
                
            this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
        } else {
            this.orgs = [await this.$store.state.$pouch.get('registry', this.$store.state.user.org_id)]
            this.c_data.org_id = this.$store.state.user.org_id
        }
        if (this.c_data.org_id) {
            if (filterByOrg('client', 'view_org', this.$store.state.user.roles)) {
                this.$set(this, 'filtered_users', (Object.values(this.$store.state.users)).filter((user) => {
                    return user.org_id == this.c_data.org_id
                }))
                // this.filtered_users = (Object.values(this.$store.state.users)).filter((user) => {
                //     return user.org_id == current_org
                // })
            } 
        }
        console.log('set users end')
        let res = await this.$store.state.$pouch.find('registry', {
            selector: {
                is_partner: true
            },
            fields: ['_id', 'name', 'is_partner', 'piva']})
        let date = (new Date()).getTime()
        this.c_data.order_date = this.c_data.order_date ? this.c_data.order_date : date
        //console.log('OP DATE', this.c_data.op_date,  this.c_data.op_date!=null ? this.c_data.order_date : date)
        this.c_data.op_date = this.c_data.op_date ? this.c_data.op_date : date
        //this.c_data.order_nr = this.c_data.order_nr ? this.c_data.order_nr: getDefaultOrderNr(this.$store.state.user)
        this.partners = res.docs
        if ((!this.c_data.assigned || this.c_data.assigned.length==0) && !isAdmin(this.$store.state.user.roles)){
            this.c_data.assigned = [this.$store.state.user._id]        
        }
        this.$nextTick(function(){
            this.$refs.opRegistry.validate()
        })
        //console.log("OPERATION REG", this.c_data)
    },
    methods: {
        getData() {
            return this.c_data
        },
        isValid() {
            return this.valid
        },
        isDateEditable() {
            return isAdmin(this.$store.state.user.roles)
        }
    },
    watch: {
        'valid': {
            handler() {
                this.$emit('update_op_registry', this.valid)
            }
        },
        'c_data.org_id': {
            handler() {
                this.$set(this, 'filtered_users', (Object.values(this.$store.state.users)).filter((user) => {
                return user.org_id == this.c_data.org_id
                }))
            }
        }
    }
    
}

</script>